import { OpenTokState } from '../reducers/opentok';
import { BroadcastingState } from '../reducers/broadcasting';
import { ChatReducerState } from '../reducers/chat';
import { ContentState } from '../reducers/content';
import { HomeState } from '../reducers/home';
import { InvitationsState } from '../reducers/invitations';
import { MediaState } from '../reducers/media';
import { ModalState } from '../reducers/modal';
import { NotesReducerState } from '../reducers/notes';
import { NotificationsState } from '../reducers/notifications';
import { SessionState } from '../reducers/session';
import { SettingsReducerState } from '../reducers/settings';
import { VideoState } from '../reducers/video';
import { ShotsState } from '../reducers/shots';
import { UserInterfaceState } from '../reducers/user-interface';
import { TeleprompterReducerState } from '../reducers/teleprompters';
import { GraphicsState } from '../reducers/graphics';
import { DebugState } from '../reducers/debug';
import { MeetingReducerState } from '../reducers/meeting';
import { CommToggleState } from '../reducers/comm-toggle';
import { GeneratedContentState } from '../reducers/generate-content';
import { IFeatureFlagsReducer } from '../reducers/blp-feature-flags';
import { TabsState } from '../reducers/tabs';
import { MasksState } from '../reducers/masks';
import { ContentChipsState } from '../reducers/content-chips';
import { ThemesState } from '../reducers/themes';

export enum EAsyncStatus {
	Incomplete = 'incomplete',
	Waiting = 'waiting',
	Error = 'error',
	Complete = 'complete'
}

export enum ChatRoomStatus {
	Presenter = 'presenter',
	Streams = 'streams',
	Direct = 'direct',
}

export enum HttpRequest {
	Get = 'GET',
	Head = 'HEAD',
	Post = 'POST',
	Put = 'PUT',
	Delete = 'DELETE',
	Connect = 'CONNECT',
	Options = 'OPTIONS',
	Trace = 'TRACE',
	Patch = 'PATCH',
}

export interface Bitrate {
	[key: string]: number;
}

export interface Action {
	type: string;
	payload: any;
	remote?: boolean; // this action came from a remote user (usually via src/socket-listeners/sync)
	id?: number;
	socket?: boolean; // if the action was dispatched from a socket listener
}

export interface ActionGeneric<T> extends Action {
	payload: T;
}

export interface AsyncAction {
	type: string;
	promise: Promise<any>
	socket?: boolean; // if the action was dispatched from a socket listener
}

export interface BackgroundImage {
	url: string;
	coverage: 'fit' | 'fill' | 'stretch' | 'none' | 'tile',
	scale: number;
}

export interface GreenroomState {
	OpenTokReducer: OpenTokState;
	BroadcastReducer: BroadcastingState;
	ChatReducer: ChatReducerState;
	ContentReducer: ContentState;
	HomeReducer: HomeState;
	InvitationsReducer: InvitationsState;
	MediaReducer: MediaState;
	ModalReducer: ModalState;
	NotesReducer: NotesReducerState;
	NotificationsReducer: NotificationsState;
	SessionReducer: SessionState;
	SettingsReducer: SettingsReducerState;
	VideoReducer: VideoState;
	ShotsReducer: ShotsState;
	UserInterfaceReducer: UserInterfaceState;
	TeleprompterReducer: TeleprompterReducerState;
	GraphicsReducer: GraphicsState;
	DebugReducer: DebugState;
	MeetingReducer: MeetingReducerState;
	CommToggleReducer: CommToggleState;
	GeneratedContentReducer: GeneratedContentState;
	FeatureFlagsReducer: IFeatureFlagsReducer;
	TabsReducer: TabsState;
	MasksReducer: MasksState;
	ContentChipsReducer: ContentChipsState
	ThemesReducer: ThemesState
}

export interface VideoRect {
	width: string;
	height: string;
	top: string;
	left: string;
}

export interface IDateObjectProps {
	weekday: string;
	day: string;
	month: string;
	hour: string;
	minute: string;
	hourType: string;
}

export interface GraphicDimensions {
	xScale: number;
	yScale: number;
}

export interface MediaDimensions {
	width?: number;
	height?: number;
}

// This can be used like keyof for values
export type valueof<T> = T[keyof T];

export type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

export type ApiError = {
	error: string;
}

// Can use instead of `{ [key: string]: Type }`
export type StringIndexObject<T> = {
    [key: string]: T
}

// Can use instead of `{ [key: number]: Type }`
export type NumberIndexObject<T> = {
    [key: number]: T
}

export interface CssPosition {
	top?: number;
	right?: number;
	bottom?: number;
	left?: number;
}

export type LogLevel = 'info' | 'warn' | 'error' | 'debug';

export enum DeviceTypes {
	Camera = 'Camera',
	Microphone = 'Microphone',
	Speakers = 'Speakers',
}

export enum ChannelAuthMethod {
	EmailPassword = 'email_password',
	SSO = 'sso',
}
